module.exports = __webpack_public_path__ + "static/patriciawork6-532ba92505f564024ed3fe81ead1642a.jpg";